const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` })
  };
};

const getAuthHeadersMultipart = () => {
  const token = localStorage.getItem('token');
  return {
    ...(token && { 'Authorization': `Bearer ${token}` })
  };
};

export const getTicketStats = async () => {
  const response = await fetch(`${API_URL}/admin/support/stats`, {
    headers: getAuthHeaders()
  });
  if (!response.ok) throw new Error((await response.json()).error || 'Failed to fetch stats');
  return response.json();
};

export const getAdminTickets = async ({ status, category, priority, assignedToMe, page = 1, limit = 30, sort = 'updatedAt', order = 'desc' } = {}) => {
  const params = new URLSearchParams({ page, limit, sort, order });
  if (status && status !== 'all') params.set('status', status);
  if (category && category !== 'all') params.set('category', category);
  if (priority && priority !== 'all') params.set('priority', priority);
  if (assignedToMe) params.set('assignedToMe', 'true');

  const response = await fetch(`${API_URL}/admin/support/tickets?${params}`, {
    headers: getAuthHeaders()
  });
  if (!response.ok) throw new Error((await response.json()).error || 'Failed to fetch tickets');
  return response.json();
};

export const getAdminTicket = async (ticketId) => {
  const response = await fetch(`${API_URL}/admin/support/tickets/${ticketId}`, {
    headers: getAuthHeaders()
  });
  if (!response.ok) throw new Error((await response.json()).error || 'Failed to fetch ticket');
  return response.json();
};

export const adminReplyToTicket = async (ticketId, { message, screenshot }) => {
  const formData = new FormData();
  formData.append('message', message);
  if (screenshot) {
    formData.append('screenshot', screenshot);
  }

  const response = await fetch(`${API_URL}/admin/support/tickets/${ticketId}/messages`, {
    method: 'POST',
    headers: getAuthHeadersMultipart(),
    body: formData
  });
  if (!response.ok) throw new Error((await response.json()).error || 'Failed to send reply');
  return response.json();
};

export const updateTicketStatus = async (ticketId, status) => {
  const response = await fetch(`${API_URL}/admin/support/tickets/${ticketId}/status`, {
    method: 'PATCH',
    headers: getAuthHeaders(),
    body: JSON.stringify({ status })
  });
  if (!response.ok) throw new Error((await response.json()).error || 'Failed to update status');
  return response.json();
};

export const assignTicket = async (ticketId, assignTo) => {
  const response = await fetch(`${API_URL}/admin/support/tickets/${ticketId}/assign`, {
    method: 'PATCH',
    headers: getAuthHeaders(),
    body: JSON.stringify({ assignTo })
  });
  if (!response.ok) throw new Error((await response.json()).error || 'Failed to assign ticket');
  return response.json();
};

export const updateTicketPriority = async (ticketId, priority) => {
  const response = await fetch(`${API_URL}/admin/support/tickets/${ticketId}/priority`, {
    method: 'PATCH',
    headers: getAuthHeaders(),
    body: JSON.stringify({ priority })
  });
  if (!response.ok) throw new Error((await response.json()).error || 'Failed to update priority');
  return response.json();
};
